import { AxiosResponse } from "axios";
import {
  AccountRepository,
  CreateAccountDTO,
} from "../../Domain/Repositories/AccountRepository";
import { Account } from "../../Model/Account";
import { SlackNotifySettings, SlackNotifySettingsPatch } from "../../Model/SlackNotifySettings";
import { api } from '../../../../api/axiosInstance';

export class AccountRepositoryImpl implements AccountRepository {
  private http = api;

  createAccount(dto: CreateAccountDTO): Promise<Account> {
    return this.http
      .post<Account>("/accounts/", dto)
      .then((r: AxiosResponse<Account>) => r.data);
  }

  getAccounts(): Promise<Account[]> {
    return this.http
      .get<Account[]>("/accounts/")
      .then((r: AxiosResponse<Account[]>) => r.data);
  }

  getAccount(id: number): Promise<Account> {
    return this.http
      .get<Account>(`/accounts/${id}/`)
      .then((r: AxiosResponse<Account>) => r.data);
  }

  updateAccount(id: number, dto: Partial<CreateAccountDTO>): Promise<Account> {
    return this.http
      .patch<Account>(`/accounts/${id}/`, dto)
      .then((r: AxiosResponse<Account>) => r.data);
  }

  deleteAccount(id: number): Promise<void> {
    return this.http.delete(`/accounts/${id}/`).then(() => undefined);
  }

  resetPassword(id: number, newPassword: string): Promise<void> {
    return this.http
      .post(`/accounts/reset-password/${id}/`, { new_password: newPassword })
      .then(() => {});
  }

  getSlackNotifySettings(): Promise<SlackNotifySettings> {
    return this.http
      .get<SlackNotifySettings>('/accounts/slack-notify-settings/')
      .then((r: AxiosResponse<SlackNotifySettings>) => r.data);
  }

  updateSlackNotifySettings(dto: SlackNotifySettingsPatch): Promise<SlackNotifySettings> {
    return this.http
      .patch<SlackNotifySettings>('/accounts/slack-notify-settings/', dto)
      .then((r: AxiosResponse<SlackNotifySettings>) => r.data);
  }
}
